import React from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import { Button, Table } from "react-bootstrap";
import { IoIosAddCircle } from "react-icons/io";

// Keys on a row that are NOT attribute ids
const NON_ATTR_KEYS = [
    "mrpprice",
    "salesprice",
    "weight",
    "length",
    "breadth",
    "height",
    "sku_code",
    "ID",
];

/**
 * AttributeMasterModal
 * Shows attribute-wise price rows (from texttilebotapi/getAttributeMaster
 * → DATA.attr_master_pre) and lets the user pick one to add to cart.
 *
 * Props:
 *  - isOpen            : boolean
 *  - toggle            : () => void  (close/cancel)
 *  - productName       : string
 *  - productImage      : string (url)
 *  - attrMasterPre     : array  (DATA.attr_master_pre)
 *  - attrMasterArr     : array  (DATA.attribute_arr filtered Type == 3)
 *  - onSelectRow       : (row, json, jsonName, selectedprice) => void
 */
const AttributeMasterModal = ({
    isOpen,
    toggle,
    productName,
    productImage,
    attrMasterPre = [],
    attrMasterArr = [],
    onSelectRow,
}) => {
    // Build { attrId: masterId } + { attrName: masterName } from a row
    const buildJsonFromRow = (row) => {
        const json = {};
        const jsonName = {};
        Object.keys(row).forEach((key) => {
            if (
                !NON_ATTR_KEYS.includes(key) &&
                row[key] &&
                typeof row[key] === "object"
            ) {
                json[key] = row[key].master_id;
                jsonName[row[key].attr_name] = row[key].master_name;
            }
        });
        return { json, jsonName };
    };

    const handleRowClick = (row) => {
        const { json, jsonName } = buildJsonFromRow(row);
        const selectedprice =
            row.salesprice && Number(row.salesprice) > 0
                ? row.salesprice
                : row.mrpprice || 0;
        onSelectRow?.(row, json, jsonName, selectedprice);
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            size="xl"
            backdrop="static"
            keyboard={false}
            className="attr-modal"
        >
            <ModalHeader toggle={toggle} className="Modal-addressheader">
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        width: "100%",
                    }}
                >
                    <span
                        style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            lineHeight: "1.3",
                            wordBreak: "break-word",
                        }}
                    >
                        {productName}
                    </span>
                    {productImage && (
                        <img
                            src={productImage}
                            alt={productName}
                            style={{
                                width: "40px",
                                height: "40px",
                                objectFit: "cover",
                                borderRadius: "8px",
                                flexShrink: 0,
                            }}
                        />
                    )}
                </div>
            </ModalHeader>

            <ModalBody style={{ padding: "12px" }}>
                {attrMasterPre.length > 0 ? (
                    <div
                        className="attr-table-scroll"
                        style={{
                            width: "100%",
                            maxHeight: "65vh",
                            overflowX: "auto",
                            overflowY: "auto",
                            WebkitOverflowScrolling: "touch",
                        }}
                    >
                        <Table
                            striped
                            bordered
                            hover
                            className="mb-0"
                            style={{ minWidth: "max-content", whiteSpace: "nowrap" }}
                        >
                            <thead
                                style={{
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                    background: "#fff",
                                }}
                            >
                                <tr>
                                    <th
                                        style={{
                                            position: "sticky",
                                            left: 0,
                                            zIndex: 3,
                                            background: "#fff",
                                            textAlign: "center",
                                        }}
                                    >
                                        #
                                    </th>
                                    {attrMasterArr.map((a) => (
                                        <th key={a.ID}>{a.Name}</th>
                                    ))}
                                    <th>Sales Price</th>
                                    <th>MRP Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {attrMasterPre.map((row, index) => (
                                    <tr key={row.ID || index}>
                                        <td
                                            style={{
                                                cursor: "pointer",
                                                position: "sticky",
                                                left: 0,
                                                zIndex: 1,
                                                background: "#fff",
                                                textAlign: "center",
                                            }}
                                            onClick={() => handleRowClick(row)}
                                        >
                                            <IoIosAddCircle size={25} />
                                        </td>
                                        {attrMasterArr.map((a) => (
                                            <td key={a.ID}>
                                                {row[a.ID]?.master_name || "---"}
                                            </td>
                                        ))}
                                        <td>{row.salesprice ?? "---"}</td>
                                        <td>{row.mrpprice ?? "---"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                ) : (
                    <div>No attribute found</div>
                )}
            </ModalBody>

            <ModalFooter>
                <Button variant="secondary" size="sm" onClick={toggle}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AttributeMasterModal;